import DropzonePreview from "../utils/DropzonePreview";
import BaseQuestionCard from "../BaseQuestionCard";
import { QUESTION_CARD_VARIANTS, SURVEY_TYPES } from "../constants/constantsSurveys";

export default function PhotoQuestionCard(props) {
  return (
    <BaseQuestionCard
      {...props}
      {...QUESTION_CARD_VARIANTS[SURVEY_TYPES.image]}
      extraContent={<DropzonePreview />}
      showRequiredImagePreview={false}
    />
  );
}